import axios from "axios";
import { ReviewRow, ReviewStatus } from "../types/review";
import { getAuthHeaders, setAuthToken } from "./auth";

const BASE_URL = process.env.REACT_APP_API_BASE_URL ?? "http://localhost:7071/api";

// Re-export setAuthToken so existing callers (ReviewPage) keep working
// without needing to know about the auth module split.
export { setAuthToken };

export async function getReviews(
  cycleName: string,
  toolName: string,
  stage: 1 | 2
): Promise<ReviewRow[]> {
  const resp = await axios.get(
    `${BASE_URL}/reviews/${cycleName}/${encodeURIComponent(toolName)}`,
    { params: { stage }, headers: getAuthHeaders() }
  );
  return resp.data.rows as ReviewRow[];
}

export async function patchReview(
  cycleName: string,
  toolName: string,
  itemId: number,
  payload: {
    stage: 1 | 2;
    decision: string;
    justification: string;
    reviewerUpn: string;
    reviewerDisplayName: string;
  }
): Promise<void> {
  await axios.patch(
    `${BASE_URL}/reviews/${cycleName}/${encodeURIComponent(toolName)}/${itemId}`,
    payload,
    { headers: getAuthHeaders() }
  );
}

export async function getReviewStatus(
  cycleName: string,
  toolName: string
): Promise<ReviewStatus> {
  const resp = await axios.get(
    `${BASE_URL}/reviews/${cycleName}/${encodeURIComponent(toolName)}/status`,
    { headers: getAuthHeaders() }
  );
  return resp.data as ReviewStatus;
}
